export const GATES = {
  CONFIGURED_TICKET_DETAIL_PROPERTIES: 'CustomerPortal:ConfiguredTicketDetailProperties',
  ADVANCED_SEARCH: 'SupportSpace:AdvancedSearch:FE'
};